const translations = {
  navigation: {
    table: 'Табела',
    customers: 'Клијенти',
    stats: 'Статистика',
    settings: 'Подешавања',
    logout: 'Излогуј се'
  },
  label: {
    accept: 'Прихватам',
    or: 'или',
    first_name: 'Име',
    last_name: 'Презиме',
    location: 'Локација',
    address: 'Адреса',
    name: 'Назив',
    person_name: 'Име',
    phone: 'Телефон',
    email: 'Мејл',
    birthday: 'Датум рођења',
    city: 'Град',
    note: 'Белешка',
    password: 'Лозинка',
    password_confirmation: 'Потврда лозинке',
    search: 'Претрага',
    category: 'Категорија',
    allCustomers: 'Сви клијенти',
    organization: 'Назив организације',
    originalProfit: 'Оригинални профит',
    chooseCurrency: 'Изабери валуту',
    chooseCountry: 'Изабери државу',
    businessPhone: 'Телефон',
    businessHours: 'Радно време',
    activate: 'Укључи',
    deactivate: 'Искључи',
    today: 'Данас',
    categories: 'Категорије',
    language: 'Језик',
    stats: 'Статистика',
    employees: 'Запослени',
    account: 'Налог',
    services: 'Услуге',
    materials: 'Материјали',
    profile: 'Профил',
    delete: 'Уклони',
    edit: 'Измени',
    newEmail: 'Нови мејл',
    repeatPassword: 'Понови лозинку',
    change: 'Промени',
    addEmployee: 'Додај запосленог',
    editEmployee: 'Измени податке запосленог',
    addCustomer: 'Додај клијента',
    editCustomer: 'Измени податке клијента',
    newCategory: 'Нова категорија',
    about: 'Општи подаци',
    country: 'Држава',
    currency: 'Валута',
    unit: 'Јединица',
    quantity: 'Количина',
    price: 'Цена',
    discount: 'Попуст',
    total: 'Укупно',
    duration: 'Трајање',
    pause: 'Пауза',
    material: 'Материјал',
    date: 'Датум',
    close: 'Затвори',
    noDataAvailable: 'Нема доступних података',
    addMaterial: 'Додај материјал',
    editMaterial: 'Измени материјал',
    addService: 'Додај услугу',
    editService: 'Измени услугу',
    actions: 'Акције',
    service: 'Услуга',
    serviceName: 'Име услуге',
    materialName: 'Име материјала',
    h: 'ч',
    min: 'мин',
    noPause: 'Без паузе',
    ml: 'мл',
    g: 'г',
    none: 'Ни једна',
    addCategory: 'Додај Категорију',
    editCategory: 'Измени Категорију',
    requestedChange: 'Захтевана промена',
    invitation: 'Позивница',
    view: 'Преглед',
    addAppointment: 'Додај термин',
    customer: 'Клијент',
    customerInfo: 'Подаци клијента',
    customerHistory: 'Историја клијента',
    noCustomer: 'Нема клијента',
    manageOrganization: 'Администратор',
    from: 'Од',
    to: 'До',
    topWorkers: 'ТОП РАДНИЦИ',
    perProfit: 'По профиту',
    perCustomers: 'По клијентима',
    created: 'Направљено',
    updated: 'Ажурирано',
    profit: 'Профит',
    appointments: 'Термини',
    notifications: 'Обавештења'
  },
  dateTime: {
    months: 'Јан_Феб_Мар_Апр_Мај_Јун_Јул_Авг_Сеп_Окт_Нов_Дец',
    days: 'Пон_Уто_Сре_Чет_Пет_Суб_Нед'
  },
  days: {
    0: 'Понедељак',
    1: 'Уторак',
    2: 'Среда',
    3: 'Четвртак',
    4: 'Петак',
    5: 'Субота',
    6: 'Недеља'
  },
  button: {
    back: 'Назад',
    login: 'Пријављивање',
    forgotPassword: 'Заборављена лозинка',
    facebookLogin: 'Facebook пријављивање',
    facebookConnect: 'Повежи Facebook налог',
    facebookDisconnect: 'Откачи Facebook налог',
    register: 'Регистрација',
    upload: 'Upload',
    remove: 'Уклони',
    update: 'Измени',
    cancel: 'Откажи',
    add: 'Додај',
    save: 'Сачувај',
    submit: 'Пошаљи',
    invite: 'Пошаљи позивницу',
    resendInvitation: 'Обнови позивницу',
    loadMore: 'Прикажи још'
  },
  message: {
    cookiePolicy: 'Ова страница користи \'колачиће\'. Уколико наставите са прегледом сајта пристајете на њихову употребу.',
    somethingWentWrong: 'Ух! Нешто је пошло напокао',
    loginFailed: 'Неуспешно пријављивање. Молимо вас проверите ваше податке за приступ',
    loginFailedEmailVerify: 'Неуспешно пријављивање. Молимо вас потврдите вашу мејл адресу',
    login: 'Улогуј се',
    homepage: 'Почетна',
    register: 'Региструј се',
    forgottenPassword: 'Заборављена лозинка',
    facebookFailed: 'Неуспешно повезивање на Facebook',
    checkYourEmail: 'Молимо вас проверите ваш мејл за даље инструкције',
    mailNotFound: 'Тражени мејл није пронађен',
    saveSuccess: 'Подаци успешно сачувани',
    saveFailed: 'Подаци нису успешно сачувани',
    removed: 'Уклоњено',

    areYouSure: 'Да ли сте сигурни?',
    removeEmployee: 'Ова акција ће уклонити запосленог',
    removeService: 'Ова акција ће уклонити услугу',
    removeMaterial: 'Ова акција ће уклонити материјал',
    removeCustomer: 'Ова акција ће уклонити клијента',
    removeCategory: 'Ова акција ће уклонити категорију',
    removeAppointment: 'Ова акција ће уклонити термин',
    badInvitation: 'Неисправна позивница',
    invitationSent: 'Позивница послата',
    joinedSalonize: 'Салонизиран',
    emailChanged: 'Емаил адреса промењена',
    welcome: {
      welcomeSalonize: 'Добродошли у Salonize!',
      followSteps: 'Хајде да подесимо налог. Испрати кораке испод.',
      firstStep: 'Прво додај своје запослене.',
      secondStep: 'Затим додај услуге.'
    },
    no_notifications: 'Нема нових обавештења',
    hasBirthday: 'има рођендан',
    passwordMismatch: 'Неисправна потврда лозинке',
    emailTaken: 'Емаил адреса заузета',
    missingLocation: 'Недостаје локација',
    noServices: 'Nема изабраних услуга'
  },
  settings: {
    account: 'Налог',
    workers: 'Радници',
    services: 'Сервиси',
    materials: 'Материјали',
    profile: 'Профил'
  },
  languages: {
    en: 'English',
    rs: 'Српски',
    hr: 'Hrvatski',
    mk: 'Македонски',
    si: 'Slovenščina'
  },
  currencies: {
    eur: 'EUR',
    rsd: 'RSD',
    hrk: 'HRK',
    chf: 'CHF',
    gbp: 'GBP',
    usd: 'USD',
    all: 'ALL',
    bam: 'BAM',
    mkd: 'MKD'
  }
}

export default translations



// WEBPACK FOOTER //
// ./src/translations/rs.js